// Copied from @atlassian/preview-panel-global-objects/src/constants.tsx
export const WORK_ITEM_GLOBAL_OBJECT_TYPE = 'jira-issue';
export const WORK_ITEM_PANEL_TYPE = 'jira-work-item';
export const JIRA_PRODUCT = 'jira';
